import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('magma-3191-render-chin-skeleton-in-ssr');
	},
};
